const topbar = {
    docs: 'Документы',
    help: 'Помощь',
};
export default Object.freeze(topbar);
